import { Link } from 'react-router-dom';
import { newsData } from '@/mocks/homeData';
import { newsImageUrls } from '@/mocks/imageUrls';
import { SectionTag, SectionTitle, SectionDescription, ArticleCard } from '@/components/base/Card';

export default function NewsSection() {
  const featuredArticle = newsData.find((n) => n.featured);
  const otherArticles = newsData.filter((n) => !n.featured);

  return (
    <section className="section-padding bg-background-50">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row items-end justify-between mb-14">
          <div>
            <SectionTag>新闻动态</SectionTag>
            <SectionTitle>最新资讯与行业洞察</SectionTitle>
            <SectionDescription>
              关注豪门国际最新动态，获取全球精英圈层的前沿资讯与深度洞见。
            </SectionDescription>
          </div>
          <Link
            to="/category/social"
            className="mt-4 md:mt-0 flex items-center space-x-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>查看全部</span>
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {featuredArticle && (
            <div className="lg:col-span-2">
              <ArticleCard
                slug={featuredArticle.slug}
                title={featuredArticle.title}
                excerpt={featuredArticle.excerpt}
                date={featuredArticle.date}
                category={featuredArticle.category}
                categorySlug="social"
                imageUrl={newsImageUrls[featuredArticle.imageSeq] || newsImageUrls['news-summit-2026']}
                featured
              />
            </div>
          )}

          <div className="flex flex-col gap-6">
            {otherArticles.map((article) => (
              <ArticleCard
                key={article.slug}
                slug={article.slug}
                title={article.title}
                excerpt={article.excerpt}
                date={article.date}
                category={article.category}
                categorySlug={article.category === '精英社交' ? 'social' : article.category === '国际投资' ? 'investment' : article.category === '品质生活' ? 'lifestyle' : article.category === '精英教育' ? 'education' : 'resources'}
                imageUrl={newsImageUrls[article.imageSeq] || newsImageUrls['news-summit-2026']}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}